import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';
import { EngineerLeaderboardResponse } from '@/types/engineerLeaderboard';

const engineerLeaderboardEndpoint = `${apiUrl}metrics/engLeaderboard/`;

export const fetchEngineerLeaderboard = async (
  timeRange: string = 'weekly'
): Promise<EngineerLeaderboardResponse> => {
  try {
    if (timeRange === 'weekly') {
      timeRange = 'this_week';
    } else if (timeRange === 'monthly') {
      timeRange = 'this_month';
    } else if (timeRange === 'yearly') {
      timeRange = 'this_year';
    }

    const requestBody = {
      date_range: timeRange,
      date_interval: null,
    };

    const response = await postWithAuth(
      engineerLeaderboardEndpoint,
      requestBody
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch engineer leaderboard: ${response.status}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch engineer leaderboard:', error);
    return {
      engineers: [],
      total_engineers: 0,
      error: 'Failed to fetch data',
    };
  }
};

/**
 * @param seatsOnly Restrict the board to the org's paid seat holders. The
 *   backend filters before ranking, so ranks and `total_engineers` describe the
 *   filtered board - never filter the response here instead, it is already
 *   sliced to the top 15.
 */
export const fetchEngineerLeaderboardByOrg = async (
  timeRange: string = 'weekly',
  orgUUID: string,
  seatsOnly: boolean = false,
  scope?: 'team' | 'org'
): Promise<EngineerLeaderboardResponse> => {
  try {
    if (timeRange === 'weekly') {
      timeRange = 'this_week';
    } else if (timeRange === 'monthly') {
      timeRange = 'this_month';
    }
    const requestBody = {
      date_range: timeRange,
      date_interval: null,
      org_uuid: orgUUID,
      seats_only: seatsOnly,
      scope,
    };
    const response = await postWithAuth(
      `${apiUrl}metrics/engLeaderboard/`,
      requestBody
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch engineer leaderboard: ${response.status}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch engineer leaderboard:', error);
    return {
      engineers: [],
      total_engineers: 0,
      error: 'Failed to fetch data',
    };
  }
};

export const fetchOrganizationTeamsLeaderboard = async (
  timeRange: string = 'weekly',
  orgUUID: string,
  teamsUUID: string[],
  seatsOnly: boolean = false
): Promise<any> => {
  try {
    if (timeRange === 'weekly') {
      timeRange = 'this_week';
    } else if (timeRange === 'monthly') {
      timeRange = 'this_month';
    }
    const response = await postWithAuth(`${apiUrl}metrics/engLeaderboard/`, {
      date_range: timeRange,
      date_interval: null,
      org_uuid: orgUUID,
      teams_uuid: teamsUUID,
      seats_only: seatsOnly,
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch organization teams leaderboard: ${response.status}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch organization teams leaderboard:', error);
    return {
      teams: [],
      total_teams: 0,
      error: 'Failed to fetch data',
    };
  }
};
